// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { xCheckoutInnerContainerStyles } from "@pace/App/SharedStyles/CheckoutPageStyles";
import { FormFieldStyle } from "@pace/MobiusOverrides/FormField";
import { creditCardDetailsEntryStyles } from "@pace/Overrides/Widgets/CheckoutReviewAndSubmit/CreditCardDetailsEntry";
import IconHelp from "@pace/XDL/Icons/IconHelp";
import { createLinkIconStyles, mergeWithCss } from "@pace/XDL/Utilities";
import { css } from "styled-components";

creditCardDetailsEntryStyles.creditCardDetailsContainer = {
    gap: 16,
};

creditCardDetailsEntryStyles.saveCardGridItem = {
    width: 6,
    css: css`
        padding-left: 11px;
    `,
};

creditCardDetailsEntryStyles.securityCodeGridItem = {
    width: 6,
    css: css`
        padding-right: 11px;
    `,
};

creditCardDetailsEntryStyles.expirationDateContainer = mergeWithCss(xCheckoutInnerContainerStyles.sectionTwoColums, {
    css: css`
        align-items: flex-start;
        width: 100%;

        ${FormFieldStyle}:last-of-type {
            margin-top: 21px;
        }
    `,
});

creditCardDetailsEntryStyles.securityHintLink = {
    ...createLinkIconStyles(IconHelp, {
        css: css`
            display: inline-block;
            ${IconWrapper} {
                position: relative;
                top: -2px;
            }
        `,
    }),
};

creditCardDetailsEntryStyles.saveCardCheckbox = {
    css: css`
        margin-top: 36px;
    `,
};
